/**
 * Matches backend apps.mosques.services.mosque_access.user_can_manage_mosque
 */
export function userCanManageMosque(user, mosque) {
  if (!user || !mosque) return false;
  if (user.is_staff || user.is_superuser) return true;
  if (['admin', 'moderator'].includes(user.role)) return true;
  const ownerId = mosque.user?.id ?? mosque.user;
  return ownerId === user.id;
}
